import React from 'react';
import './ods.css'
import ControlledCarousel from './carrusel'
import { Fade } from "react-awesome-reveal";




function OdS() {
    return (
    <div className='odscontainer' id='odscontainer'>
        <div className="odstexto">
            <Fade bottom delay={100} duration={1000}  fraction={0.2}><h2>ORQUESTA DE SEÑORITAS</h2></Fade>
            <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                <p>Bratsche, Gesang, Komposition, Produktion</p>
                
            </Fade>
        </div>
        
        <div className="odsfotos">
            <ControlledCarousel></ControlledCarousel> 
        </div>
        <div className="odstexto">
            <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                <p>
                    Orquesta de Señoritas ist ein Frauenensemble, das 2009 in Rosario, Argentinien, gegründet wurde. Es
hat auf verschiedenen nationalen und internationalen Bühnen gespielt, hauptsächlich in Europa
(Deutschland, Schweiz, Frankreich, Schweden, Türkei). Ihre letzte Show „Indómita“, in der sowohl
klassische als auch eigene Tangos zu hören sind, wurde sowohl national als auch international

präsentiert. Sie haben zwei Alben veröffentlicht: „Al límite“ (2021) und „Vivo en Alemania“, ein Live-
Material aus Deutschland (2023).

                </p>
                <p>Orquesta de Señoritas vertritt einen starken feministischen Ansatz.

Die Mitglieder fördern durch ihre Kunst die Gleichstellung und die Rolle der Frauen, besonders im
Tango. Jede ihrer Aufführungen ist nicht nur ein musikalisches Erlebnis, sondern auch eine kulturelle
Erklärung für Gleichberechtigung und die Teilhabe von Frauen.</p>
            </Fade>
        </div>
        <Fade bottom delay={100} duration={1000}  fraction={0.3}>
                    <div className="videoOdSYT">
                        <iframe className='odsiframe' width="1296" height="729" src="https://www.youtube.com/embed/KTsnPjedJCU" title="OdS Tour" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </Fade>
        <Fade bottom delay={100} duration={1000}  fraction={0.3}>
        <div className="redesOdS">
            <p>orquestadesrtas@gmail.com</p>
            <div className="linksOdS">
                <div className="igOdS">
                <a href="https://www.instagram.com/orquestadesrtas?igsh=enV0cW13N3JpdDB3" target='blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" height="46" width="40" viewBox="0 0 448 512"><path fill="#ffffff" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
                    
                </a>
            </div>
            <div className="ytOdS">
                <a href="https://www.youtube.com/@OrquestaDeSrtas" target='blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" height="56" width="52" viewBox="0 0 576 512"><path fill="#ffffff" d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>
                </a>
            </div>
            <div className="ytOdS">
                <a href="https://open.spotify.com/intl-de/artist/24uUZFgntTSdrgSyp7xC6c?si=YO0vcnKDTWilHR_jlEfhuA " target='blank'>
                    <svg xmlns="http://www.w3.org/2000/svg" height="45" width="45" viewBox="0 0 496 512"><path fill="#ffffff" d="M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"/></svg>
                </a>
            </div>
            </div>
        </div>
        </Fade>
    </div>
)
}

export default OdS